var exports = {
  "fJ": "PinnedIssueContainer__vsm37n",
  "hQ": "contentContainer__YWSx_8",
  "Y3": "titleOptionsContainer__za47RM",
  "N_": "Link___MAuNs",
  "m4": "Octicon__oAwWNb",
  "K0": "IconButton__n9qqur",
  "tJ": "metadataContainer__Ut21pG",
  "Js": "issueMetadata__Z8VAxr",
  "Ud": "commentCountContainer__yVi8_h",
  "Ls": "commentIcon__ksAnhI",
  "UU": "commentCountText__8Y5W2N",
};

module.exports = exports;
